var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEqualWeight = function SvgEqualWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A4AAB6",
    d: "M6 0a6 6 0 1 1 0 12A6 6 0 0 1 6 0m1.354 3.646a.5.5 0 1 0-.708.708L7.793 5.5H3a.5.5 0 0 0 0 1h4.793L6.646 7.646a.5.5 0 1 0 .708.708L9.707 6z"
  })));
};
export default SvgEqualWeight;